<template>
    <b-modal
        id="add-organization-modal"
        ref="add-organization-modal"
        size="md"
        :title="$t('management.add_student')"
        modal-class="apprentice-default-modal create-internship-tag"
        ok-only
        :ok-title="$t('common.close')"
        @show="load()">
        <design-2021-apprentice-data-table
            :items="allAddableOrganizations"
            :fields="fields">
            <template v-slot:cell(action)="data">
                <b-button
                    class="btn-sign-in btn-module-sign-in remove-icon-margin"
                    v-b-tooltip.hover
                    variant="primary-icon-only"
                    :title="$t('common.add')"
                    @click="signUp(data.item.id)">
                </b-button>
            </template>
        </design-2021-apprentice-data-table>
    </b-modal>
</template>

<script>
// import {ords} from "../../../app";
// import moment from "moment";
export default {
    name: 'design-2021-management-organizations-add-modal-component',
    props: ['organizationsIn'],
    data() {
        return {
            loaded: false,
            allOrganizations: [],
            includedOrganizations: [],
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    methods: {
        load() {
            if (!this.loaded) {
                this.getallOrganizations();
                this.includedOrganizations = this.organizationsIn.map((org) => org.id);
                this.loaded = true;
            }
        },
        getallOrganizations() {
            this.axios.get(this.routes.managementOrganizationsGet()).then(
                (response) => {
                    this.allOrganizations = response.data;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        signUp(orgId) {
            this.axios.post(this.routes.managementOrganizationsAdd(orgId)).then(
                (response) => {
                    this.alert.success();
                    this.includedOrganizations.push(orgId);
                    const orgObject = this.allOrganizations.find((org) => org.id === orgId);
                    this.$emit('addOrg', orgObject);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        removeOrgFromIncludedOrganizations(id) {
            this.includedOrganizations = this.includedOrganizations.filter((x) => x !== id);
        },
    },
    computed: {
        allAddableOrganizations() {
            if (this.loaded === false) {
                return [];
            } else {
                const filteredOrganizations = this.allOrganizations.filter(
                    (org) => !this.includedOrganizations.includes(org.id),
                );
                return filteredOrganizations.map((org) => {
                    return {
                        id: org.id,
                        name: org.name,
                    };
                });
            }
        },
    },
};
</script>

<style scoped lang="scss">
.sidebar {
    margin-bottom: $grid-gutter-width;
}

.internships {
    .internship-item {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

        .internship-card {
            &.closed {
                filter: grayscale(1);
            }
        }
    }
}

.internship-show-actions {
    display: flex;
    flex-direction: row;
    align-items: center;

    > .btn {
        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }

        &:before {
            margin-right: 0;
        }
    }
}

.not-found {
    margin-top: #{3 * map-get($grid-gutter-spacing, 'twenty-one')};
}
</style>
